// extracted by mini-css-extract-plugin
export default {"privacyPolicy":"PrivacyPolicy_privacyPolicy__TU59H","title":"PrivacyPolicy_title__jqc0y","contentTitle":"PrivacyPolicy_contentTitle__vu3+V","content":"PrivacyPolicy_content__Xckc+"};